import {ResultadoDeRastreoSchema} from '@cnc/contracts';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import {pedir} from './cliente';
import {refrescarDatos} from './refrescar';

export const rutaListaDelRastreador = '/api/seguimiento/rastreador/lista';

// PDF y Excel del rastreador de navieras: "revisar" no guarda; "aplicar" guarda.
export function useCargarRastreador() {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: ({archivos, modo}: {archivos: File[]; modo: 'revisar' | 'aplicar'}) => {
      const cuerpo = new FormData();
      for (const a of archivos) cuerpo.append('archivos', a, a.name);
      cuerpo.append('modo', modo);
      return pedir('seguimiento/rastreador/cargar', ResultadoDeRastreoSchema, {method: 'POST', body: cuerpo});
    },
    onSuccess: async resultado => {
      if (resultado.aplicado) await refrescarDatos(cliente);
    },
  });
}

// Del rastreador se sube solo el PDF (y el JSON de Maersk) mas reciente de cada
// BL (la carpeta guarda uno por dia) y el Excel: asi se puede elegir toda la
// carpeta sin subir miles.
export function archivosDelRastreador(archivos: File[]): {elegidos: File[]; descartados: number} {
  const recientes = new Map<string, File>();
  const otros: File[] = [];
  for (const a of archivos) {
    const m = /^(.+)_(\d{4}-\d{2}-\d{2})\.(pdf|json)$/i.exec(a.name);
    if (!m) {
      if (/\.(pdf|json|xlsx|xlsm)$/i.test(a.name)) otros.push(a);
      continue;
    }
    const clave = `${m[1]!.toUpperCase()}.${m[3]!.toLowerCase()}`;
    const actual = recientes.get(clave);
    if (!actual || m[2]! > /(\d{4}-\d{2}-\d{2})\.\w+$/.exec(actual.name)![1]!) recientes.set(clave, a);
  }
  const elegidos = [...recientes.values(), ...otros];
  return {elegidos, descartados: archivos.length - elegidos.length};
}
